import { render } from "./ClasElem_Elemento.vue?vue&type=template&id=9e6c86e4"
import script from "./ClasElem_Elemento.vue?vue&type=script&lang=js"
export * from "./ClasElem_Elemento.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__